var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('rp-nav',{attrs:{"page-name":_vm.pageName,"pages":_vm.pages}}),_c('router-view',{key:_vm.$route.fullPath,staticClass:"px-64"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }